import { ReactNode, useEffect, useRef, useState } from "react";
import { gsap } from "gsap/gsap-core";

export default function AddPoolElement({ children, title, isAdding, setIsAdding, className = "" }) {
    const childRef = useRef(null);
    const contentHeight = useRef(0);

    useEffect(() => {
        // Salvo l'altezza originale per usarla nelle animazioni
        if (childRef.current && isAdding) {
            // Imposto temporaneamente la visibilità per misurare l'altezza reale
            childRef.current.style.height = 'auto';
            childRef.current.style.opacity = '0';
            contentHeight.current = childRef.current.offsetHeight;

            // Animazione di apertura
            gsap.fromTo(childRef.current,
                {
                    height: 0,
                    opacity: 0
                },
                {
                    height: contentHeight.current,
                    opacity: 1,
                    duration: 0.4,
                    ease: 'power2.inOut'
                }
            );
        } else if (childRef.current && !isAdding) {
            // Animazione di chiusura
            gsap.to(childRef.current, {
                height: 0,
                opacity: 0,
                duration: 0.4,
                ease: 'power2.inOut'
            });
        }
    }, [isAdding]);

    return (
        <div className={`bg-white border border-gray-200 rounded-lg shadow-sm mb-4 ${className}`}>
            {/* Intestazione del pannello con titolo e pulsante */}
            <div className="flex justify-between items-center p-4 bg-gray-50 border-b border-gray-200 rounded-t-lg cursor-pointer" 
                 onClick={() => setIsAdding(!isAdding)}>
                <div className="flex items-center">
                    <h5 className="text-lg font-medium text-gray-700">{title}</h5>
                </div>
                {isAdding && (
                    <div>
                        <button 
                            type="button" 
                            className="inline-flex items-center justify-center p-2 rounded-full text-gray-600 hover:text-gray-800 transition-all duration-200"
                            aria-expanded={isAdding}
                        >
                            <i className="fa-solid fa-circle-xmark text-lg"></i>
                        </button>
                    </div>
                )}
            </div>

            {/* AREA CUSTOM PER INSERIMENTO DATI */}
            <div
                ref={childRef}
                className="overflow-hidden px-4"
                style={{
                    height: 0,
                    opacity: 0
                }}
            >
                <div className="py-4">
                    {children}
                </div>
            </div>
        </div>
    );
}